"use client";

import { c as _c } from "react/compiler-runtime";
import type { ApiProfileRepRatesState } from "@/entities/IProfile";
import { formatNumberWithCommas } from "@/helpers/Helpers";
import { useMemo } from "react";
export default function UserProfileTooltipTopRep(t0) {
  const $ = _c(8);
  const {
    repRates
  } = t0;
  let t1;
  bb0: {
    if (!repRates?.rating_stats?.length) {
      let t2;
      if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = [];
        $[0] = t2;
      } else {
        t2 = $[0];
      }
      t1 = t2;
      break bb0;
    }
    let t2;
    if ($[1] !== repRates.rating_stats) {
      t2 = [...repRates.rating_stats].sort(_temp).slice(0, 3);
      $[1] = repRates.rating_stats;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    t1 = t2;
  }
  const topRepCategories = t1;
  if (topRepCategories.length === 0) {
    return null;
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span className="tw-font-medium tw-text-iron-400">Top Rep</span>;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== topRepCategories) {
    t3 = topRepCategories.map(_temp2);
    $[4] = topRepCategories;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t3) {
    t4 = <div className="tw-mt-4">{t2}<div className="tw-flex tw-flex-wrap tw-gap-2 tw-mt-2">{t3}</div></div>;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}
function _temp2(rep) {
  return <div key={rep.category} className="tw-flex tw-items-center tw-gap-x-1.5 tw-px-2.5 tw-py-1 tw-rounded-md tw-bg-iron-800/60 tw-ring-1 tw-ring-inset tw-ring-iron-700/50"><span className="tw-text-xs tw-font-medium tw-text-iron-200 tw-truncate tw-max-w-[120px]">{rep.category}</span><span className={`tw-text-xs tw-font-semibold ${rep.rating > 0 ? "tw-text-green" : "tw-text-red"}`}>{formatNumberWithCommas(rep.rating)}</span></div>;
}
function _temp(a, b) {
  return b.rating - a.rating || b.contributor_count - a.contributor_count;
}